import script from "./ScreenshotsGallery.vue?vue&type=script&lang=ts&setup=true"
export * from "./ScreenshotsGallery.vue?vue&type=script&lang=ts&setup=true"

import "./ScreenshotsGallery.vue?vue&type=style&index=0&id=6778fba4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6778fba4"]])

export default __exports__